import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
import { verify_token } from '@/api/api'; // Placeholder for your API function

export const useAuthStore = defineStore('auth', () => {
  // Reactive state for user and permissions
  const user = ref(null);
  const myself = ref(null);
  const subscription_status = ref(null);
  const permissions = ref(null);
  const isInitialized = ref(false); // New state to track initialization

  // Function to set authentication data
  const setAuthData = (data) => {
    user.value = data.user;
    myself.value = data.myself;
    subscription_status.value = data.subscription;
    // Ensure myself exists before setting branchName to avoid errors
    if (myself.value && data.branchName) {
      myself.value.branchName = data.branchName;
    }
    permissions.value = data.new_permissions;
  };

  // Function to clear authentication data (e.g., on logout)
  const clearAuthData = () => {
    user.value = null;
    myself.value = null;
    subscription_status.value = null;
    permissions.value = null;
    isInitialized.value = false; // Reset initialization state
  };

  // New asynchronous method to initialize the store
  const initializePinia = async () => {
    // Skip if already initialized
    if (isInitialized.value && myself.value) {
      return;
    }

    // Get the authentication token from cookies (adjust the key as needed)
    const token = cookies.get('userToken');
    const c_id = cookies.get('c_id') ?? null;

    if (token) {
      try {
        // Fetch authentication data using the token
        const userData = await verify_token(token, c_id, 'header');
        setAuthData(userData); // Set the fetched data
      } catch (error) {
        console.error('Failed to fetch auth data: ' + error);
        clearAuthData(); // Clear data on error (e.g., invalid token)
      }
    } else {
      clearAuthData(); // No token means no user is logged in
    }

    // Mark as initialized regardless of success or failure
    isInitialized.value = true;
  };

  // Expose state and methods
  return { user, myself, permissions, subscription_status, isInitialized, setAuthData, clearAuthData, initializePinia };
});